export default "__VITE_ASSET__66f4f599__"